webpackJsonp([35783957827783],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ width: "6.39em", height: "1em", version: 1, viewBox: "0 0 464 77" }, props),
	    _react2.default.createElement(
	      "g",
	      { fill: "currentColor" },
	      _react2.default.createElement("path", { d: "M256 14l-3-8h-15l-1 1v3l3 4h16zm43-8h-12l-2 1-3 7h16l3-6c1-1 0-2-1-2h-1zm23 0h-11l-2 2v6h15V7l-2-1zm72 8l-4-3c-5-4-12-6-19-6-9-1-18 3-25 9h48zm41 0l-4-8-2-1h-2l-1 2-3 7h12zm-215 0a35 35 0 0 0-47 0h47zm34 0h-17l5 11h16l-4-11zm3 45l7 14 2 1 2-1 1-3 6-11h-18zm21-34h12l6-11h-13l-5 11z" }),
	      _react2.default.createElement("path", { d: "M277 25h1l5-11h-4l-5 11zm29 34v12l2 2h12c1 0 2-1 1-2V59h-15zm0-45v11h15V14h-15zm62 5c5 0 10 2 13 5 2 1 3 0 4-1l6-7c1-1 0-2-1-2h-46l-8 11h19c3-4 8-6 13-6zm20 40h-49a35 35 0 0 0 52 5c1-1 0-2-1-3l-2-2zm70 11l-5-11h-54l-5 12c-1 2 2 2 3 2h10l4-5 2-5h26l4 9 6 1h8c1 0 2-2 1-3zm-26-56h-12l-5 11h22l-5-11zm-238 6c4 0 9 2 12 5h19l-8-11h-47c-3 3-6 7-7 11h19c3-3 7-5 12-5zm3 39h-32c6 9 16 15 27 15 11 1 22-4 29-13 0-1 3-3 1-2h-25zm74-17c-1 0-1-2-2-1l-1-1-7-15h-16l15 34h17l16-34h-15l-7 17z" }),
	      _react2.default.createElement("path", { d: "M271 42l7-17h-1l-7 16v1zm38 17h15V25h-15v34zm82 0l-5-5c-3-1-4 2-7 3-7 3-15 2-21-4-7-6-8-18-2-26 1-1 2-2 0-2h-17c-5 11-4 24 3 34h49zm30-9l8-16 1 3 6 13h-15zm34 9l-15-34h-22l-16 34h53zm-261 0c-8-1-14-7-16-15-2-7 1-14 6-19h-19c-5 11-4 24 3 34h26zm31-34h-16c5 5 8 12 6 19-2 8-8 14-16 15h26c7-10 8-23 3-34h-3zM83 7c0-1-2-2-4-1H69c-2 0-1 2-1 4l-2 7c-1 3-1 7 1 10s-1 6-3 8c-4 3-10 1-12-3l-2-6c-2-3-2-8-1-11l2-6c0-1 0-3-2-3H37l-1 4-2 7c-1 4 0 7 2 10l1 7c2 9 11 16 20 17a23 23 0 0 0 25-23l-2-7c0-3 0-6 2-9l1-5z" }),
	      _react2.default.createElement("path", { d: "M48 59l-4-1H25V29l-3-9 2-8 1-5c-1-2-3-2-5-2h-9c-2 1-1 3-1 4 0 3-3 5-3 8-1 4 0 7 2 11l1 8v18c-1 3-4 5-3 9v8c1 2 3 1 5 1h36c2 0 1-3 1-4v-8l-1-1zm71 0h-9V29c0-3-3-6-2-9h13l9 5 4 1c7 9 5 24-5 30-3 2-6 3-10 3zm33-32c-1-3-5-4-6-6l-4-8c-7-5-15-8-24-7H97c-3 1-1 5-3 7-2 4-2 10 1 14v24c-1 3-3 6-2 9v11c0 2 2 2 4 2h23c10-1 20-6 25-14 2 0 4 0 4-2 6-9 7-21 3-30z" }),
	      _react2.default.createElement(
	        "text",
	        {
	          className: "sous-titre",
	          x: 54,
	          y: 76,
	          fill: "#000",
	          fontSize: 29,
	          fontFamily: "'DIN-Alternate-Bold',arial-black"
	        },
	        "une ville en fragments"
	      )
	    )
	  );
	};
	
	exports.default = SvgComponent;

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABZwAAAdwAQMAAABlABk7AAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMApkkmy+UAAAWtSURBVHja7M4xDQAACANBBgb8K8YDCUmHq4Dv1ds6MgUNHfEEDX1PDTQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ09LI7BwIAAAAAQP6vjVBgenp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enoau3MgAAAAAADk/9oIBaanp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp7E7BwIAAAAAQP6vjVBgenp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enoau3MgAAAAAADk/9oIBaanp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp7U7x0QAgDAAxPy7hhfQ7nCJgkhLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLD6SlpaUvaWlpaWlp6UhLS0tLS0tHWlpaWlpaOtLS0tLS0tKRlpaWlpaWjrS0tLS0tHSkpaWl/0uPpKUX0tILaemF9DvpA2LGdT38x4gkAAAAAElFTkSuQmCC"

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAMAAACgaw2xAAAA5FBMVEUAAAB+fn51dXV0dHR/f391dXVhYWFvb2+EhIR2dnZubm58fHxkZGR4eHhnZ2eJiYlsbGx7e3tvb29oaGhpaWmfn593d3eTk5NnZ2dxcXGAgICOjo6goKBsbGypqalmZmZLS0sZGRkAAACDg4M+Pj4kJCR3d3crKysVFRWAgIBHR0dCQkI4ODgNDQ2Pj4+Li4ttbW1mZmYnJycRERGlpaWGhoZ8fHxqamofHx8JCQkFBQWenp5ycnJgYGBeXl5bW1tUVFRMTExLS0szMzMxMTGrq6uhoaGZmZmYmJiTk5NYWFgvLy99yEVNAAAAIXRSTlMAAgkEBhkZEA1nMjCAKicTDEI/NCEgHRkUzaWAU1NGPCb7XpUiAAABQklEQVQY02WRB27DMAxFSUke2Wl2dyXPeMQre6/u+9+ncWyjKEoIEPAfH0iAwJ7b0Kow+Fc1SgaSRFGBJigKUYDVM6BSKAMFAgDNP4aKDBGbRGIDAMD00Ssgl4/ixZIpoZhFudNHSIOqorTLUtrducZPaSzRF0N33M3s9o4gQr7jA0D3fuu5jrsbDbXhYypl42RWBefkeZa3149RWFLzGa059zmfW9a3bs3dtTaBXgYoF37CDeN8iMyZqQ2nZm4Q4HbC+YI7s0C75MHqQy0Uf8H5MjmuQzMIJqvXt5sMVEr6Qvi+sN7H5v6w08bjEmYGVM9L2xbWKIyGnxNTG5UI5LU1eCLszTTURpGnfxWg0b1xDVsIgwuxFMKOy4XB+nVHj3ls8Pikyx0ALAgAkWRZrtcqNSAIiI38KIxVelJDxd87/QBe2CI1HSRItwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAMAAAAYGszCAAAA5FBMVEUAAACDg4N9fX1+fn5zc3N4eHh2dnaKiop7e3t+fn6FhYVqamqCgoKKioqQkJB5eXmJiYmIiIhycnJsbGxBQUExMTF4eHiBgYF6enpjY2NaWlqLi4uCgoKBgYF5eXl3d3eJiYlnZ2eDg4NsbGxnZ2d8fHxCQkIsLCyBgYF8fHxsbGxdXV1WVlZQUFBNTU08PDwzMzMODg4DAwNmZmZZWVlKSkpGRkY+Pj44ODgvLy8gICAXFxeUlJRxcXFfX19SUlIICAjNzc27u7uoqKidnZ2IiIh2dnZzc3NpaWk6OjoUFBQKCgq3Sw2eAAAAJnRSTlMAAwwJIIBAKBkVgIB/ZzUkEdXNzc3NvqqYgIB/Z2dhVERAMSgoB9K5C/sAAADMSURBVBjTZc/VjsJAAIXhM/Xi6+67M3X3YovL+78PtIQQwnf5X5zkAOAgKlAIzny8cY3Gqwy53SY8hxrhIbReWtd6f9bheHweogRjaEa2HSVW3AQIqRaNgeV6KXW9InZCXeCVHkBu7HVR5kmSOcaIUhqKAFTRycrAZ66bWrkfjOMl9nr3prcZ+wVjZmgMqamj0sGTnZVbn2rT/4mm91Hrqmh6QcCs1XyRjjQcqO8Snp2csbvbaHCM+HuUhK8f4FfAN06qg5fkqwd0UdsBXGIYTj/3gpYAAAAASUVORK5CYII="

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(441);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	__webpack_require__(443);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _btnHabitationDeQuebec = __webpack_require__(92);
	
	var _btnHabitationDeQuebec2 = _interopRequireDefault(_btnHabitationDeQuebec);
	
	var _btnFrancoisDePontGrave = __webpack_require__(90);
	
	var _btnFrancoisDePontGrave2 = _interopRequireDefault(_btnFrancoisDePontGrave);
	
	var _btnMarcLescarbot = __webpack_require__(99);
	
	var _btnMarcLescarbot2 = _interopRequireDefault(_btnMarcLescarbot);
	
	var _btnLePalaisMontcalm = __webpack_require__(97);
	
	var _btnLePalaisMontcalm2 = _interopRequireDefault(_btnLePalaisMontcalm);
	
	var _btnSymeon = __webpack_require__(102);
	
	var _btnSymeon2 = _interopRequireDefault(_btnSymeon);
	
	var _btnHenrietteBelley = __webpack_require__(94);
	
	var _btnHenrietteBelley2 = _interopRequireDefault(_btnHenrietteBelley);
	
	var _btnLeBoulevardDeLaCapitale = __webpack_require__(96);
	
	var _btnLeBoulevardDeLaCapitale2 = _interopRequireDefault(_btnLeBoulevardDeLaCapitale);
	
	var _btnDinaBelanger = __webpack_require__(88);
	
	var _btnDinaBelanger2 = _interopRequireDefault(_btnDinaBelanger);
	
	var _btnEdouardFiset = __webpack_require__(89);
	
	var _btnEdouardFiset2 = _interopRequireDefault(_btnEdouardFiset);
	
	var _btnLIlotFleurie = __webpack_require__(95);
	
	var _btnLIlotFleurie2 = _interopRequireDefault(_btnLIlotFleurie);
	
	var _btnMarieSavonnieresDeLaTroche = __webpack_require__(100);
	
	var _btnMarieSavonnieresDeLaTroche2 = _interopRequireDefault(_btnMarieSavonnieresDeLaTroche);
	
	var _btnLouisFortier = __webpack_require__(98);
	
	var _btnLouisFortier2 = _interopRequireDefault(_btnLouisFortier);
	
	var _btnHabitationDesHurons = __webpack_require__(93);
	
	var _btnHabitationDesHurons2 = _interopRequireDefault(_btnHabitationDesHurons);
	
	var _btnNicolasVincent = __webpack_require__(101);
	
	var _btnNicolasVincent2 = _interopRequireDefault(_btnNicolasVincent);
	
	var _btnGuySiouiDurand = __webpack_require__(91);
	
	var _btnGuySiouiDurand2 = _interopRequireDefault(_btnGuySiouiDurand);
	
	var _logoLudovica = __webpack_require__(137);
	
	var _logoLudovica2 = _interopRequireDefault(_logoLudovica);
	
	var _voiture = __webpack_require__(917);
	
	var _voiture2 = _interopRequireDefault(_voiture);
	
	var _voiture3 = __webpack_require__(918);
	
	var _voiture4 = _interopRequireDefault(_voiture3);
	
	var _plis = __webpack_require__(915);
	
	var _plis2 = _interopRequireDefault(_plis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    return _react2.default.createElement(
	        'div',
	        { style: { width: '100%', textAlign: 'center' }, className: 'interface' },
	        _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'accueil' } }),
	        _react2.default.createElement(
	            'div',
	            { className: 'titre' },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/a-propos/' },
	                _react2.default.createElement(_logoLudovica2.default, { style: { color: '#fff' } })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'voiture1', style: { position: "absolute", top: "36vw", left: "39vw" } },
	            _react2.default.createElement('img', { src: _voiture2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'voiture2', style: { position: "absolute", top: "45vw", left: "54vw" } },
	            _react2.default.createElement('img', { src: _voiture4.default, alt: '' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'plis', style: { position: "absolute", top: "0", left: "0", width: "100%", height: "auto" } },
	            _react2.default.createElement('img', { src: _plis2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "1.75vw", left: "3vw" } },
	            _react2.default.createElement(_btnHabitationDeQuebec2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "7.25vw", left: "30vw" } },
	            _react2.default.createElement(_btnMarcLescarbot2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "3.5vw", left: "52vw" } },
	            _react2.default.createElement(_btnSymeon2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "4.25vw", left: "70vw" } },
	            _react2.default.createElement(_btnLePalaisMontcalm2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "33vw", left: "1vw" } },
	            _react2.default.createElement(_btnFrancoisDePontGrave2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "36vw", left: "79vw" } },
	            _react2.default.createElement(_btnHenrietteBelley2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "46vw", left: "40vw" } },
	            _react2.default.createElement(_btnLeBoulevardDeLaCapitale2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "57vw", left: "8vw" } },
	            _react2.default.createElement(_btnDinaBelanger2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "76vw", left: "6vw" } },
	            _react2.default.createElement(_btnEdouardFiset2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "55vw", left: "75vw" } },
	            _react2.default.createElement(_btnLIlotFleurie2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "80vw", left: "51vw" } },
	            _react2.default.createElement(_btnGuySiouiDurand2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "84vw", left: "79vw" } },
	            _react2.default.createElement(_btnLouisFortier2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "107vw", left: "16vw" } },
	            _react2.default.createElement(_btnHabitationDesHurons2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "105vw", left: "44vw" } },
	            _react2.default.createElement(_btnNicolasVincent2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", top: "110vw", left: "65vw" } },
	            _react2.default.createElement(_btnMarieSavonnieresDeLaTroche2.default, null)
	        )
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-975707cce0834596f6ea.js